export const cultureDefinitions = {
  cs: {
    dialects: ['cs', 'cs-CZ'],
    momentLocale: 'cs',
    languageTag: 'cs-CZ',
  },
  da: {
    dialects: ['da'],
    momentLocale: 'da',
    languageTag: 'da-DK',
  },
  de: {
    dialects: ['de', 'de-AT', 'de-DE', 'de-LI', 'de-LI', 'de-CH'],
    momentLocale: 'de-at',
    languageTag: 'de-DE',
  },
  en: {
    dialects: [
      'en',
      'en-AU',
      'en-BZ',
      'en-CA',
      'en-CB',
      'en-IE',
      'en-JM',
      'en-NZ',
      'en-PH',
      'en-ZA',
      'en-TT',
      'en-GB',
      'en-US',
      'en-ZW',
    ],
    momentLocale: 'en',
    languageTag: 'en-US',
  },
  es: {
    dialects: ['es', 'es-ES', 'es-MX'],
    momentLocale: 'es',
    languageTag: 'es-ES',
  },
  et: {
    dialects: ['et', 'et-EE'],
    momentLocale: 'et',
    languageTag: 'et-EE',
  },
  fi: {
    dialects: ['fi', 'fi-FI'],
    momentLocale: 'fi',
    languageTag: 'fi-FI',
  },
  fr: {
    dialects: ['fr', 'fr-BE', 'fr-CA', 'fr-FR', 'fr-LU', 'fr-MC', 'fr-CH'],
    momentLocale: 'fr',
    languageTag: 'fr-FR',
  },
  hu: {
    dialects: ['hu', 'hu-HU'],
    momentLocale: 'hu',
    languageTag: 'hu-HU',
  },
  it: {
    dialects: ['it', 'it-IT'],
    momentLocale: 'it',
    languageTag: 'it-IT',
  },
  nl: {
    dialects: ['nl', 'nl-BE', 'nl-NL'],
    momentLocale: 'nl',
    languageTag: 'nl-NL',
  },
  nb: {
    dialects: ['nb', 'no', 'nn', 'nb-NO', 'nn-NO'],
    momentLocale: 'nb',
    languageTag: 'nb-NO',
  },
  pl: {
    dialects: ['pl', 'pl-PL'],
    momentLocale: 'pl',
    languageTag: 'pl-PL',
  },
  ro: {
    dialects: ['ro'],
    momentLocale: 'ro',
    languageTag: 'ro-RO',
  },
  ru: {
    dialects: ['ru', 'ru-RU'],
    momentLocale: 'ru',
    languageTag: 'ru-RU',
  },
  sk: {
    dialects: ['sk', 'sk-SK'],
    momentLocale: 'sk',
    languageTag: 'sk-SK',
  },
  sl: {
    dialects: ['sl', 'sl-SI'],
    momentLocale: 'sl',
    languageTag: 'sl-SI',
  },
  sv: {
    dialects: ['sv', 'sv-SE', 'sv-FI'],
    momentLocale: 'sv',
    languageTag: 'sv-SE',
  },
  lv: {
    dialects: ['lv', 'lv-LV'],
    momentLocale: 'lv',
    languageTag: 'lv-LV',
  },
  lt: {
    dialects: ['lt', 'lt-LT'],
    momentLocale: 'lt',
    languageTag: 'lt-LT',
  },
  pt: {
    dialects: ['pt', 'pt-BR'],
    momentLocale: 'pt',
    languageTag: 'pt-BR',
  },
  tr: {
    dialects: ['tr', 'tr-TR'],
    momentLocale: 'tr',
    languageTag: 'tr-TR',
  },
};
